<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{ $t("tlt.pelletizingMaterialCost") }}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/prd"><span>{{$t('tlt.production')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/prd/pelletizingProductionResult"><span>{{$t('tlt.pelletizingProductionResult')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/pelletizingMaterialCost"><span>{{$t('tlt.pelletizingMaterialCost')}}</span></router-link></li>
                </ul>
            </div>
            <!-- <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('pelletizingMaterialCost')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>                       
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div> -->
        </div>
        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div
                        id="collapseOne"
                        class="collapse show "
                        aria-labelledby="headingOne"
                        data-parent="#accordionFilter"
                        >
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.planCode") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="planCodeFilter"/>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.locName") }}:
                                    </label>
                                    <input class="form-control" type="text" v-model="plantFilter"/>
                                </div>                                 
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.shift") }} :
                                    </label>
                                    <select class="form-control" type="text" v-model="shiftFilter">
                                        <option value>{{ $t("lbl.basic.select.one") }}</option>
                                        <option value="甲">{{ $t("lbl.shift.A") }}</option>
                                        <option value="乙">{{ $t("lbl.shift.B") }}</option>  
                                        <option value="丙">{{ $t("lbl.shift.C") }}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.startDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="startDayFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.endDay") }} :
                                    </label>
                                    <mmf-datepicker      v-model="endDayFilter"></mmf-datepicker>
                                </div> 
                                <div class="form-group col-md-2">
                                    <label class="control-label">
                                        {{ $t("lbl.basic.materialName") }} :
                                    </label>
                                    <input class="form-control" type="text" v-model="materialFilter"/>
                                </div> 
                                <div class="col-lg-12 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" 
                                         v-on:click="MMFClearFilter('pelletizingMaterialCost')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('pelletizingMaterialCost')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <div id="pelletizingMaterialCostResultTable" class="content">
                <div class="card my-1">
                    <div
                        id="collapseTwo"
                        class="collapse show"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionResult"
                        >
                        <div class="card-body">
                            <mmf-table  entity="pelletizingMaterialCost" inline-actions-enabled singleChoice disableInlineView>
                            </mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>        
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from 'vuex-map-fields';
import {gridFields, filterFields}  from "@/model/prd/productionExecution/pelletizing/PelletizingMaterialCost";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from '@/components/MmfDatepicker';

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
    getterType: 'pelletizingMaterialCost/getField',
    mutationType: 'pelletizingMaterialCost/updateField',
});

export default {
  name: "pelletizingMaterialCostList",
  data () {
    return {
    //   checkedItems: []
    }
  },
  components: { MmfTable, MmfDatepicker},
  computed: {
        // generate and add getters and setters using the filter names defined in
        // entity model
        ...mapFields(filterFields),
        ...mapState({
            rows: state => state.pelletizingMaterialCost.rows,
            checkedItems: state => state.pelletizingMaterialCost.checkedItems,
            showNoResultAlert: state => state.base.showNoResultAlert,
            tableColumns: gridFields
        })
  },
  methods: {
    ...mapActions("base", ["MMFselectRow", "MMFselectAllRows", "MMFNew", 
    "MMFEdit", "MMFLoadRows", "MMFDelete", "MMFClearFilter"])
  },
  mounted(){
  }
};
</script>
